import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/vuex/store'
import Home from '@/views/Home.vue'
import NotFound from '@/views/404.vue'

let routes = [
    {
        path: '/login',
        component: require('@/views/Login'),
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/',
        hidden: true,
        redirect: { path: '/main' }
    },
    {
        path: '/',
        component: Home,
        name: '用户中心',
        iconCls: 'el-icon-user',//图标样式class
        children: [
            { path: '/main', component: require('@/views/Main'), name: '用户信息' },
            { path: '/bills', component: require('@/views/ruis/user/BillList'), name: '账单记录' },
            { path: '/txs', component: require('@/views/ruis/user/TxList'), name: '提现记录',hidden:true },
            /* { path: '/test', component: require('@/views/charts/echarts'), name: 'test' },*/
        ]
    },
    {
        path: '/',
        component: Home,
        name: '资源中心',
        iconCls: 'el-icon-suitcase',//图标样式class
        children: [
            { path: '/file/boxs', component: require('@/views/ruis/file/FlboxList'), name: '文件夹' },
            { path: '/file/fls', component: require('@/views/ruis/file/FileList'), name: '文件管理' },
            { path: '/file/boxfls', component: require('@/views/ruis/file/BoxFileList'), name: '文件夹管理',hidden:true },
            { path: '/file/orders', component: require('@/views/ruis/user/OrderList'), name: '下载记录' },
        ]
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

Vue.use(VueRouter)
const router = new VueRouter({routes})

import { getToken,removeToken } from '@/common/js/storage';
router.beforeEach((to, from, next) => {
//NProgress.start();
if (to.path == '/login') {
    removeToken();
    next();
    return;
}
if (to.path == '/404') {
    next();
    return;
}
// let token = getToken();
// if(!token||token==''){
//   next({ path: '/login' })
//   return;
// }
// if (to.path == '/') {
//   next({ path: '/models' })
//   return;
// }
/*if(store.state.userinfo.login==true){
    next();
    return;
}*/
store.dispatch('getLgInfo').then(()=>{
    if(store.state.userinfo.login==true){
        next();
    }else{
        next(`/login?redirect=${to.path}`);
    }
}).catch(err=>{
    console.log('getLgInfo err:',err)
    next(`/login?redirect=${to.path}`);
});
})

export default router;


// WEBPACK FOOTER //
// ./src/router.js